import menu from './menu'
import serverSide from './server-side'

// export default [menu]
export default [serverSide]
